import Box, { BoxProps } from '@mui/material/Box';
import animationData from 'assets/lotties/otp-animation.json';
import LottiePlayer from 'components/LottiePlayer';
import './index.css';
import React from 'react';

export interface OtpAnimationProps extends BoxProps {}

const OtpAnimation: React.FC<OtpAnimationProps> = React.memo((props) => {
    return (
        <React.Fragment>
            <Box
                {...props}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                className="otp-animation-container"
            >
                <LottiePlayer loop={false} animationData={animationData} />
            </Box>
        </React.Fragment>
    );
});

export default React.memo(OtpAnimation);
